import ImportTimeoffModal from 'modules/employees/components/ImportTimeoffModal'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'
import { useEmployeesImporter } from 'modules/employees/lib/employeesImporterContext'

const ImportTimeoffModalPage = () => {
  const onClose = useOnCloseGoToList()
  const importer = useEmployeesImporter()

  return <ImportTimeoffModal onClose={onClose} importer={importer} />
}

export default ImportTimeoffModalPage
